import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import { formatDate } from '../../utils/date';
import { nameToUrl } from '../../utils/url';

const RaceCardLink = ({
    courseName, courseUid, raceDatetime,
    raceInstanceUid: raceUid, children,
}) => {
    if (!courseName || !courseUid || !raceDatetime || !raceUid) {
        return null;
    }

    const date = formatDate(raceDatetime, 'Y-MM-DD');
    const url = `/racecards/${courseUid}/${nameToUrl(courseName)}/${date}/${raceUid}`;
    return (
        <a
            className="ui-link ui-link_table js-popupLink js-navigate-url"
            href={url}
        >
            { children }
            <Svg
                iconName="right"
                className="ui-icon ui-icon__btn chevronIcon"
                size="XSmall"
            />
        </a>
    );
};

RaceCardLink.propTypes = {
    courseName: PropTypes.string,
    courseUid: PropTypes.number,
    raceInstanceUid: PropTypes.number,
    raceDatetime: PropTypes.string,
    children: PropTypes.node,
};

export default RaceCardLink;



// WEBPACK FOOTER //
// ./src/js/shared/links/RaceCardLink.jsx